import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/molecules/DarkMode/dark-mode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/molecules/LanguageSwitcher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/navigation/header-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/organisms/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/organisms/Header/SessionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Modals"] */ "/vercel/path0/app/components/organisms/Modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobListingPage"] */ "/vercel/path0/app/components/pages/jobs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/svg/logo_vectorized.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/svg/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
